import { contactData } from '@/mocks/home';

export default function SectionContact() {
  return (
    <section
      id="contact"
      className="py-16 md:py-20 bg-background-100"
    >
      <div className="max-w-[1920px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block text-xs font-medium text-secondary-400 bg-secondary-500/10 px-3 py-1 rounded-full mb-3">
            联系我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            {contactData.title}
          </h2>
          <p className="text-sm text-foreground-400 mt-2 mb-2">{contactData.subtitle}</p>
          <p className="text-sm md:text-base text-foreground-300 leading-relaxed mb-8">
            {contactData.description}
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-background-200/70 rounded-xl border border-background-300/40 p-6 text-center">
              <div className="w-12 h-12 mx-auto rounded-full bg-primary-500/10 flex items-center justify-center mb-3">
                <i className="ri-mail-line text-primary-500 text-xl"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">电子邮箱</div>
              <div className="text-sm font-medium text-foreground-100 break-all">{contactData.email}</div>
            </div>
            <div className="bg-background-200/70 rounded-xl border border-background-300/40 p-6 text-center">
              <div className="w-12 h-12 mx-auto rounded-full bg-accent-500/10 flex items-center justify-center mb-3">
                <i className="ri-wechat-line text-accent-500 text-xl"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">微信公众号</div>
              <div className="text-sm font-medium text-foreground-100">{contactData.wechat}</div>
            </div>
            <div className="bg-background-200/70 rounded-xl border border-background-300/40 p-6 text-center">
              <div className="w-12 h-12 mx-auto rounded-full bg-secondary-500/10 flex items-center justify-center mb-3">
                <i className="ri-qq-line text-secondary-500 text-xl"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">QQ群号</div>
              <div className="text-sm font-medium text-foreground-100">{contactData.qq}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}